'use client'

import { useDestinationContext } from '@/src/contexts'

import DestinationHero from './destinationHero'

interface DestinationHeroWrapperProps {
    isMobile: boolean
}

const DestinationHeroWrapper: React.FC<DestinationHeroWrapperProps> = ({ isMobile }) => {
    const { destinationData: { sections } } = useDestinationContext()
    const { hero } = sections

    return (
        <DestinationHero
            heading={hero.heading}
            subheading={hero.subheading}
            cityName={hero.cityName}
            countryName={hero.countryName}
            topOrigins={hero.stats.topOrigins}
            topAirlines={hero.stats.topAirlines}
            weeklyArrivals={hero.stats.weeklyArrivals}
            isMobile={isMobile}
        />
    )
}

export default DestinationHeroWrapper
